/*
 * @Author: Michael
 * @Date: 2019-03-13 10:38:53
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-09-10 14:35:47
 * 编辑页面获取数据
 */

import Vue from 'vue';
import store from '@/store';
import fetch from '@/common/api/fetch';
import { wechatPreviewConfig } from '@/mixins/wechatConfig';
import { AxiosPromiseData, AxiosPromiseError } from '@/common/interface';
import getActivityType from '@/common/utils/getActivityType';
import getUrlParam from '@/common/utils/getUrlParam';
import getMetarialData from '@/mixins/getMetarialData';
import getSMSData from '@/mixins/getSMSData';

export default function getEditDetail(): any {
  const broadcastId: string = getUrlParam('broadcastId') as string;
  const newUrlTypeList: Array<string> = ['gachaType', 'distributeType'];
  const isNewUrlType = newUrlTypeList.includes(getActivityType());
  if (broadcastId && !isNewUrlType) {
    if (getActivityType() === 'poseType') {
      getAIInfo(broadcastId); // AI招生
    } else if (getActivityType() === 'tyType') {
      getTyDetail(broadcastId); // 集赞
    } else {
      getOtherInfo(broadcastId);
    }
  }
  if (broadcastId && isNewUrlType) {
    const param = { activityId: broadcastId };
    fetch.Sales('anon/businessShow/getActivityContent', param).then((res: AxiosPromiseData) => {
      const data = res.result;
      console.log('对应data', data);
      console.log('相应content和parameter', JSON.parse(data.content), JSON.parse(data.parameter));

      // 扭蛋
      if (getActivityType() === 'gachaType') {
        const { title, deadline, instName, instId, startTime, instVOList = [], madeByOrg, instIds = ['0'] } = data;
        const remoteData = {
          title,
          instId,
          instName,
          deadline: Number(deadline),
          startTime: Number(startTime),
          instIds,
          instVOList,
          madeByOrg: !!madeByOrg
        };

        const content = JSON.parse(data.content);
        const parameter = JSON.parse(data.parameter);
        const { ladderGroupList } = content;
        const { needAuthCode } = parameter;
        const payload = {
          remoteData,
          content,
          parameter
        };
        if (getUrlParam('type') !== 'check' && !getUrlParam('adminId')) {
          store.dispatch('getDetailData', payload).then(() => {
            getSMSData();
          });
        } else {
          store.dispatch('getDetailData', payload);
        }

        if (content.documentTitle) {
          store.dispatch('changeDocumentTitle', content.documentTitle);
        }
        if (needAuthCode) {
          store.dispatch('switchSMSVerify', needAuthCode);
        }
        if (content.gachaTypeParameter) {
          const additionalInfoList = res.result.additionalInfo.prizes;
          for (var i = 0; i < additionalInfoList.length; i++) {
            content.gachaTypeParameter.prize.proList[i].id = additionalInfoList[i].id;
            content.gachaTypeParameter.prize.proList[i].name = additionalInfoList[i].name;
            content.gachaTypeParameter.prize.proList[i].chanceOfWin = additionalInfoList[i].chanceOfWin;
            content.gachaTypeParameter.prize.proList[i].description = additionalInfoList[i].description;
            content.gachaTypeParameter.prize.proList[i].left = additionalInfoList[i].left;
            content.gachaTypeParameter.prize.proList[i].total = additionalInfoList[i].total;
            content.gachaTypeParameter.prize.proList[i].url = additionalInfoList[i].url;
          }
          store.dispatch('getGachaTypeParameter', content.gachaTypeParameter);
        }
        if (data.additionalInfo.prizes) {
          store.dispatch('updatePrizeList', data.additionalInfo.prizes);
        }
        store.dispatch('changeViewBackground', content.viewBackground);
        store.dispatch('changeContactQrcode', content.contactQrcode);
        store.dispatch('changeSignupItemConfig', content.signupItemConfig);
        store.dispatch('changeShowBarrage', content.showBarrage);
        store.dispatch('changeShowData', content.showData == undefined ? true : content.showData);
        store.dispatch('changeJoinNumber', data.joinNumber || 0);
        store.dispatch('changeScanNumber', data.browseNumber || 0);
        store.dispatch('changeGroupImageList', content.groupImageList);
        store.dispatch('switchPotentialJoin', parameter.needLimitNormalStu);
        store.dispatch('toggleGachaType', parameter.kind == 2 ? 'prize' : 'scholarship');
        store.dispatch('changeInstPhone', content.instPhone);

        // 兼容-处理活动说明-扭蛋
        if (!content.activityIntros && content.activityRule) {
          const payload = [{ type: 'text', value: content.activityRule }];
          store.dispatch('replaceActivityIntros', payload);
        }
        // 活动说明开关
        if (content.activitySwitch === false) {
          store.dispatch('changeActivitySwitch', content.activitySwitch);
        } else {
          store.dispatch('changeActivitySwitch', true);
        }
        // 联系方式开关
        if (content.contactSwitch === false) {
          store.dispatch('changeContactSwitch', content.contactSwitch);
        } else {
          store.dispatch('changeContactSwitch', true);
        }
        // 机构简介开关
        if (content.institutionSwitch === false) {
          store.dispatch('changeInstitutionSwitch', content.institutionSwitch);
        } else {
          store.dispatch('changeInstitutionSwitch', true);
        }

        parameter.kind == 2 && store.dispatch('changeOldPrizeList', JSON.parse(JSON.stringify(content.gachaTypeParameter.prize.proList)));

        const payload1 = {
          value: parameter.limitNumber,
          type: parameter.limitKind === 1 ? 'dayTimes' : 'totalTimes'
        };
        store.dispatch('changeSectionInfo', payload1);
      } else if (getActivityType() === 'distributeType') {
        // 分销
        const { title, deadline, instName, instId, startTime, instAddress, instVOList = [], instIds = ['0'], supportPay, channel } = data;
        const remoteData = {
          title,
          instId,
          instName,
          deadline: Number(deadline),
          startTime: Number(startTime),
          instAddress,
          instIds,
          instVOList
        };

        const content = JSON.parse(data.content);
        const parameter = JSON.parse(data.parameter);
        console.log('分销', content, parameter);

        const { courseName, limitBuyerNum, courseOriginPrice, courseRushPrice } = content;
        const { needAuthCode } = parameter;
        const payload = {
          remoteData,
          content,
          parameter
        };
        content.distributeTypeParameter.limitBuyerNum = limitBuyerNum;
        if (getUrlParam('type') !== 'check' && !getUrlParam('adminId')) {
          store.dispatch('getDetailData', payload).then(() => {
            getSMSData();
          });
        } else {
          store.dispatch('getDetailData', payload);
        }

        if (content.documentTitle) {
          store.dispatch('changeDocumentTitle', content.documentTitle);
        }
        if (needAuthCode) {
          store.dispatch('switchSMSVerify', needAuthCode);
        }
        if (content.distributeTypeParameter) {
          store.dispatch('changeDistributeParameter', content.distributeTypeParameter);
        }
        store.dispatch('changeContactQrcode', content.contactQrcode);
        store.dispatch('changeSignupItemConfig', content.signupItemConfig);
        store.dispatch('changeShowBarrage', content.showBarrage);
        store.dispatch('changeShowData', content.showData == undefined ? true : content.showData);
        store.dispatch('changeJoinNumber', data.joinNumber || 0);
        store.dispatch('changePayNumber', { number: data.payNumber || 0 }); // 购买人数
        store.dispatch('changeLeftQuota', data.leftQuota);
        store.dispatch('changeScanNumber', data.browseNumber || 0);
        store.dispatch('switchPotentialJoin', parameter.needLimitNormalStu);
        store.dispatch('changeInstPhone', content.instPhone);

        // 兼容-处理活动说明-分销
        if (!content.activityIntros && content.activityRule) {
          const payload = [
            {
              type: 'text',
              value: content.activityRule
            }
          ];
          store.dispatch('replaceActivityIntros', payload);
        }

        // 活动说明开关
        if (content.activitySwitch === false) {
          store.dispatch('changeActivitySwitch', content.activitySwitch);
        } else {
          store.dispatch('changeActivitySwitch', true);
        }

        // 联系方式开关
        if (content.contactSwitch === false) {
          store.dispatch('changeContactSwitch', content.contactSwitch);
        } else {
          store.dispatch('changeContactSwitch', true);
        }
        // 机构简介开关
        if (content.institutionSwitch === false) {
          store.dispatch('changeInstitutionSwitch', content.institutionSwitch);
        } else {
          store.dispatch('changeInstitutionSwitch', true);
        }
        store.dispatch('changeSectionInfo', {
          value: courseName,
          type: 'courseName'
        });
        store.dispatch('changeSectionInfo', {
          value: limitBuyerNum,
          type: 'limitBuyerNum'
        });
        store.dispatch('changeSectionInfo', {
          value: Number((courseOriginPrice / 100).toFixed(2)),
          type: 'courseOriginPrice'
        });
        store.dispatch('changeSectionInfo', {
          value: Number((courseRushPrice / 100).toFixed(2)),
          type: 'courseRushPrice'
        });

        store.dispatch('changeSupportPay', supportPay || false);
        store.dispatch('changeChannel', channel || '');
      }
    });
  }
  wechatPreviewConfig();
}
// 获取AI招生
function getAIInfo(broadcastId: string): any {
  const param = {
    activityId: broadcastId,
    instId: getUrlParam('instId')
  };
  fetch.pureUrl('sales/anon/admissions/loadActivity', param).then((res: any) => {
    const data = res.result;
    const { title, deadline, instName, instId, startTime, instVOList = [], madeByOrg, instIds = ['0'], isInvalid } = data;
    console.log('AI-data', data);

    const remoteData = {
      title,
      instId,
      instName,
      deadline: Number(deadline),
      startTime: Number(startTime),
      instIds,
      instVOList,
      madeByOrg: !!madeByOrg
    };

    const content = JSON.parse(data.content);
    const parameter = JSON.parse(data.parameter);
    console.log('AI-content', JSON.parse(data.content));
    const { ladderGroupList, activityIntros, activityRule, contactQrcode } = content;
    const { needAuthCode } = parameter;
    const payload = {
      remoteData,
      content,
      parameter
    };
    store.dispatch('changeIsInvalid', isInvalid);
    if (getUrlParam('type') !== 'check' && !getUrlParam('adminId')) {
      store.dispatch('getDetailData', payload).then(() => {
        getSMSData();
      });
    } else {
      store.dispatch('getDetailData', payload);
    }

    if (content.documentTitle) {
      store.dispatch('changeDocumentTitle', content.documentTitle);
    }
    if (needAuthCode) {
      store.dispatch('switchSMSVerify', needAuthCode);
    }
    if (content.gachaTypeParameter) {
      const additionalInfoList = res.result.additionalInfo.prizes;
      for (var i = 0; i < additionalInfoList.length; i++) {
        content.gachaTypeParameter.prize.proList[i].id = additionalInfoList[i].id;
        content.gachaTypeParameter.prize.proList[i].name = additionalInfoList[i].name;
        content.gachaTypeParameter.prize.proList[i].chanceOfWin = additionalInfoList[i].chanceOfWin;
        content.gachaTypeParameter.prize.proList[i].description = additionalInfoList[i].description;
        content.gachaTypeParameter.prize.proList[i].left = additionalInfoList[i].left;
        content.gachaTypeParameter.prize.proList[i].total = additionalInfoList[i].total;
        content.gachaTypeParameter.prize.proList[i].url = additionalInfoList[i].url;
      }
      store.dispatch('getGachaTypeParameter', content.gachaTypeParameter);
    }
    if (data.additionalInfo && data.additionalInfo.prizes) {
      store.dispatch('updatePrizeList', data.additionalInfo.prizes);
    }
    store.dispatch('changeViewBackground', content.viewBackground);
    // store.dispatch('changeContactQrcode', content.contactQrcode);
    store.dispatch('changeSignupItemConfig', content.signupItemConfig);
    store.dispatch('changeShowBarrage', content.showBarrage);
    store.dispatch('changeShowData', content.showData == undefined ? true : content.showData);
    store.dispatch('changeJoinNumber', data.joinNumber || 0);
    store.dispatch('changeScanNumber', data.browseNumber || 0);
    store.dispatch('changeGroupImageList', content.groupImageList);
    store.dispatch('switchPotentialJoin', parameter.needLimitNormalStu);
    store.dispatch('toggleGachaType', parameter.kind == 2 ? 'prize' : 'scholarship');
    store.dispatch('changeInstPhone', content.instPhone);
    parameter.kind == 2 && store.dispatch('changeOldPrizeList', JSON.parse(JSON.stringify(content.gachaTypeParameter.prize.proList)));

    const payload1 = {
      value: parameter.limitNumber,
      type: parameter.limitKind === 1 ? 'dayTimes' : 'totalTimes'
    };
    store.dispatch('changeSectionInfo', payload1);
    // 兼容-处理活动说明-AI
    if (!activityIntros) {
      const payload = [];
      if (activityRule) {
        payload.push({
          type: 'text',
          value: activityRule
        });
      }
      if (contactQrcode) {
        payload.push({
          type: 'img',
          value: contactQrcode
        });
      }
      store.dispatch('replaceActivityIntros', payload);
    }
  });
}
// 获取集赞
function getTyDetail(broadcastId: string): any {
  const param = {
    broadcastId,
    openId: store.state.openId
  };
  fetch
    .post('c/xm/show/ty/detail', param)
    .then((res: AxiosPromiseData) => {
      const data = res.data;
      console.log('集赞-对应data', res.data);
      const { title, deadline, instName, instId, instIds, leftPrizeNum } = data;
      const remoteData: any = {
        title,
        instId,
        instName,
        deadline: Number(data.deadline),
        startTime: Number(data.startTime)
      };
      instIds && (remoteData.instIds = instIds);
      const content = JSON.parse(data.content);
      const parameter = JSON.parse(data.parameter);
      console.log('对应content-集赞', content);
      console.log('对应parameter', parameter);
      const { ladderGroupList } = content;
      const { needAuthCode } = parameter;
      const payload = {
        remoteData,
        content,
        parameter
      };

      store.dispatch('changeJoinNumber', data.joinNumber || 0);
      store.dispatch('changeScanNumber', data.browseNumber || 0);
      if (getUrlParam('type') !== 'check' && !getUrlParam('adminId')) {
        store.dispatch('getDetailData', payload).then(() => {
          getSMSData();
        });
      } else {
        store.dispatch('getDetailData', payload);
      }

      if (content.documentTitle) {
        store.dispatch('changeDocumentTitle', content.documentTitle);
      }
      if (needAuthCode) {
        store.dispatch('switchSMSVerify', needAuthCode);
      }

      // 兼容-处理活动说明-集赞
      if (!content.activityIntros && content.activityRule) {
        const payload = [
          {
            type: 'text',
            value: content.activityRule
          }
        ];
        store.dispatch('replaceActivityIntros', payload);
      }
      // 兼容-活动说明开关-集赞
      if (content.activitySwitch === false) {
        store.dispatch('changeActivitySwitch', content.activitySwitch);
      } else {
        store.dispatch('changeActivitySwitch', true);
      }

      // 兼容-联系方式开关-集赞
      if (content.contactSwitch === false) {
        store.dispatch('changeContactSwitch', content.contactSwitch);
      } else {
        store.dispatch('changeContactSwitch', true);
      }
      // 兼容-机构简介开关-集赞
      if (content.institutionSwitch === false) {
        store.dispatch('changeInstitutionSwitch', content.institutionSwitch);
      } else {
        store.dispatch('changeInstitutionSwitch', true);
      }

      store.dispatch('changeSectionInfo', { type: 'prizeName', value: content.prizeName });
      store.dispatch('changeSectionInfo', { type: 'prizeDesc', value: content.prizeDesc });
      store.dispatch('changeSectionInfo', { type: 'prizePic', value: content.prizePic });
      // 兼容-奖品描述-集赞
      if (!content.prizeIntros) {
        const _prizeIntros = [];
        if (content.prizeDesc) {
          _prizeIntros.push({
            type: 'text',
            value: content.prizeDesc
          });
        }
        if (content.prizePic) {
          let _list = content.prizePic.split('@').filter((item: string) => {
            return item;
          });
          for (let i = 0; i < _list.length; i++) {
            _prizeIntros.push({
              type: 'img',
              value: _list[i]
            });
          }
        }
        store.dispatch('changeSectionInfo', { type: 'prizeIntros', value: _prizeIntros || [] });
      } else {
        store.dispatch('changeSectionInfo', { type: 'prizeIntros', value: content.prizeIntros || [] });
      }
      store.dispatch('changeShowBarrage', content.showBarrage);
      store.dispatch('changeShowData', content.showData == undefined ? true : content.showData);
      store.dispatch('changeViewBackground', content.viewBackground);
      store.dispatch('changeLeftQuota', leftPrizeNum);
      const tempParameter = Object.assign({}, parameter);
      window.prizeNum = parameter.prizeNum;
      tempParameter.prizeNum = parameter.prizeNum;
      tempParameter.prizeLeftCount = parameter.prizeNum;
      tempParameter.unitNum = parameter.unitNum;
      tempParameter.goodValue = parameter.goodValue;
      tempParameter.normalValue = parameter.normalValue;
      tempParameter.badValue = parameter.badValue;
      tempParameter.intervalTime = Number((parameter.intervalTime / 60).toFixed(2));
      store.dispatch('changeTyTypeParameter', tempParameter);
      if (content.chooseDegree.index === 3) {
        let count = 0;
        let chance = 0;
        count = parameter.unitNum / (parameter.goodValue * 0.25 + parameter.normalValue * 0.65 + parameter.badValue * 0.1);

        if (count <= 1) {
          chance = 1;
        } else if (count > 1 && count < 35) {
          chance = -0.018 * count + 0.664;
        } else {
          chance = 1 / (1.72 * count + 25);
        }
        const payload = {
          chance: Math.round(chance * 100),
          count: Math.round(count)
        };
        store.dispatch('changeChanceCount', payload);
      }
      if (content.chooseDegree.index === 0) {
        store.dispatch('changeChanceCount', { chance: 57, count: 5 });
      }
      if (content.chooseDegree.index === 1) {
        store.dispatch('changeChanceCount', { chance: 41, count: 14 });
      }
      if (content.chooseDegree.index === 2) {
        store.dispatch('changeChanceCount', { chance: 30, count: 20 });
      }

      if ((parameter as any).isLimited && getUrlParam('type') === 'reEdit') {
        const limitObject = {
          limitFlag: parameter.isLimited,
          limitFlagNumber: parameter.limitNum
        };
        store.dispatch('changeLimitFlag', limitObject);
      }
    })
    .catch((error: AxiosPromiseError) => {
      if (error.resultCode === 1403) {
        Vue.$toast.error('活动不存在');
      }
    });
}
function getOtherInfo(broadcastId: string): any {
  const param = { activityId: broadcastId };
  fetch
    .Sales('anon/businessShow/getActivityContent', param)
    .then((res: AxiosPromiseData) => {
      const data = res.result;
      console.log('对应result', res.result);
      const { title, deadline, instName, instId, instIds, leftQuota, completeGroupNum, openGroupNum, fullGroupNum, supportPay, channel } = data;
      const { wechatMiniOnlineStatus, xmPayRegisterStatusEnum } = store.state;
      const isCopy = getUrlParam('state') == 'copy';

      const remoteData: any = {
        title,
        instId,
        instName,
        deadline: Number(data.deadline),
        startTime: Number(data.startTime)
      };
      instIds && (remoteData.instIds = instIds);
      const content = JSON.parse(data.content);
      const parameter = JSON.parse(data.parameter);
      console.log('对应content', content);
      console.log('对应parameter', parameter);
      console.log('state', store.state);

      const { needAuthCode } = parameter;
      const payload = {
        remoteData,
        content,
        parameter
      };

      store.dispatch('changeJoinNumber', data.joinNumber || 0);
      store.dispatch('changeScanNumber', data.browseNumber || 0);

      store.dispatch('changeSupportPay', supportPay || false); // 是否收款类型
      store.dispatch('changeChannel', channel || ''); // 支付通道

      if (getUrlParam('type') !== 'check' && !getUrlParam('adminId')) {
        store.dispatch('getDetailData', payload).then(() => {
          getSMSData();
        });
      } else {
        store.dispatch('getDetailData', payload);
      }

      if (content.documentTitle) {
        store.dispatch('changeDocumentTitle', content.documentTitle);
      }
      if (needAuthCode) {
        store.dispatch('switchSMSVerify', needAuthCode);
      }

      // 兼容-处理活动说明
      if (!content.activityIntros && content.activityRule) {
        const payload = [
          {
            type: 'text',
            value: content.activityRule
          }
        ];
        store.dispatch('replaceActivityIntros', payload);
      }
      // 活动说明开关
      if (content.activitySwitch === false) {
        store.dispatch('changeActivitySwitch', content.activitySwitch);
      } else {
        store.dispatch('changeActivitySwitch', true);
      }
      // 兼容-活动说明开关
      if (content.activitySwitch === false) {
        store.dispatch('changeActivitySwitch', content.activitySwitch);
      } else {
        store.dispatch('changeActivitySwitch', true);
      }
      // 兼容-联系方式开关
      if (content.contactSwitch === false) {
        store.dispatch('changeContactSwitch', content.contactSwitch);
      } else {
        store.dispatch('changeContactSwitch', true);
      }
      // 兼容-机构简介开关
      if (content.institutionSwitch === false) {
        store.dispatch('changeInstitutionSwitch', content.institutionSwitch);
      } else {
        store.dispatch('changeInstitutionSwitch', true);
      }

      // 微传单
      if (getActivityType() === 'lessonType') {
        store.dispatch('switchCanPay', { status: parameter.needPay });
        store.dispatch('changePayNumber', { number: parameter.payAmount / 100 });
        store.dispatch('changePayType', { payType: content.payType });
        store.dispatch('changeLeftQuota', leftQuota);
      }
      // 团购
      if (getActivityType() === 'groupType') {
        const groupData = {
          groupCreateNumber: openGroupNum,
          groupCompleteNumber: completeGroupNum,
          groupFullNumber: fullGroupNum
        };
        store.dispatch('changeGroupNumber', groupData);
        store.dispatch('changeSectionInfo', { type: 'courseName', value: content.courseName });
        store.dispatch('changeSectionInfo', { type: 'courseDesc', value: content.courseDesc });
        store.dispatch('changeSectionInfo', { type: 'coursePic', value: content.coursePic });

        // 兼容-未成团列表开关
        if (parameter.unGroupSwitch === false) {
          store.dispatch('changeUnGroupSwitch', parameter.unGroupSwitch);
        } else {
          store.dispatch('changeUnGroupSwitch', true);
        }
        // 兼容-拼团失败自动取消报名开关
  if (parameter.autoCancel === true) {
    store.dispatch('changeAutoCancel', parameter.autoCancel);
  } else {
    store.dispatch('changeAutoCancel', false);
  }
        // 兼容-多课程
        if (!content.courseType) {
          store.dispatch('changeSectionInfo', { type: 'courseType', value: 'ONE' });
        } else {
          store.dispatch('changeSectionInfo', { type: 'courseType', value: content.courseType });
        }
        // 兼容-课程列表
        if (!content.courseGroupList) {
          // 兼容-团购课程信息
          let _courseIntros = content.courseIntros;
          if (!content.courseIntros) {
            const intros = [];
            if (content.courseDesc) {
              intros.push({
                type: 'text',
                value: content.courseDesc
              });
            }
            if (content.coursePic) {
              let _list = content.coursePic.split('@').filter((item: string) => {
                return item;
              });
              for (let i = 0; i < _list.length; i++) {
                intros.push({
                  type: 'img',
                  value: _list[i]
                });
              }
            }
            _courseIntros = intros;
          }
          let _ladderGroupList = content.ladderGroupList;
          if (!content.ladderGroupList) {
            _ladderGroupList = [{ groupSize: parameter.groupSize, groupPrice: parameter.minPrice / 100 }];
            store.dispatch('changeLadderGroup', [{ groupSize: parameter.groupSize, groupPrice: parameter.minPrice / 100 }]);
          }
          let _courseGroupList = [
            {
              seqNo: 1,
              courseCover: '',
              courseName: content.courseName,
              courseIntros: _courseIntros,
              originPrice: parameter.maxPrice / 100,
              ladderGroupList: _ladderGroupList
            }
          ];
          store.dispatch('changeSectionInfo', { type: 'courseGroupList', value: _courseGroupList });
        } else {
          store.dispatch('changeSectionInfo', { type: 'courseGroupList', value: content.courseGroupList });
        }

        store.dispatch('changeSectionInfo', { type: 'currentPrice', value: parameter.minPrice / 100 });
        store.dispatch('changeSectionInfo', { type: 'originPrice', value: parameter.maxPrice / 100 });
        store.dispatch('changeSectionInfo', { type: 'groupNumber', value: parameter.groupNum });
        store.dispatch('changeSectionInfo', { type: 'personNumber', value: parameter.groupSize });
        store.dispatch('changeGroupSwitch', parameter.participantType);

        store.dispatch('changePayNumber', { number: parameter.payAmount / 100 });
        store.dispatch('changePayType', { payType: content.payType });
        store.dispatch('switchCanPay', { status: parameter.needPay });
        store.dispatch('changeVirtualGroup', parameter.virtualGroup);

        window.groupNum = parameter.groupNum;
      }
      // 砍价
      if (getActivityType() === 'bargainType') {
        store.dispatch('switchCanPay', { status: parameter.needPay });
        store.dispatch('switchMustMinPay', parameter.mustMinPay);
        store.dispatch('changeSectionInfo', { type: 'prizeName', value: content.prizeName });
        store.dispatch('changeSectionInfo', { type: 'prizeDesc', value: content.prizeDesc });
        store.dispatch('changeSectionInfo', { type: 'prizePic', value: content.prizePic });
        // 兼容-奖品描述-砍价
        if (!content.prizeIntros) {
          const _prizeIntros = [];
          if (content.prizeDesc) {
            _prizeIntros.push({
              type: 'text',
              value: content.prizeDesc
            });
          }
          if (content.prizePic) {
            let _list = content.prizePic.split('@').filter((item: string) => {
              return item;
            });
            for (let i = 0; i < _list.length; i++) {
              _prizeIntros.push({
                type: 'img',
                value: _list[i]
              });
            }
          }
          store.dispatch('changeSectionInfo', { type: 'prizeIntros', value: _prizeIntros || [] });
        } else {
          store.dispatch('changeSectionInfo', { type: 'prizeIntros', value: content.prizeIntros || [] });
        }

        const tempParameter = Object.assign({}, parameter);
        window.prizeNum = parameter.prizeNum;
        tempParameter.prizeNum = parameter.prizeNum;
        tempParameter.prizeLeftCount = parameter.prizeNum;
        tempParameter.minPrice = parameter.minPrice / 100;
        tempParameter.maxPrice = parameter.maxPrice / 100;
        tempParameter.minCutPrice = parameter.minCutPrice / 100;
        tempParameter.maxCutPrice = parameter.maxCutPrice / 100;
        tempParameter.intervalTime = Number((parameter.intervalTime / 60).toFixed(2));
        store.dispatch('changeBargainParameter', tempParameter);
        store.dispatch('changeLeftQuota', leftQuota);
        const count = ((parameter.maxPrice - parameter.minPrice) * 2) / (parameter.maxCutPrice + parameter.minCutPrice);
        let chance = 0;
        if (count == 1) {
          chance = 1;
        } else if (count >= 2 && count < 45) {
          chance = 0.96 - 0.018 * count;
        } else if (count >= 45) {
          chance = 0.8 / (count - 40);
        }
        const payload = {
          chance: Math.round(chance * 100),
          count: Math.round(count)
        };
        store.dispatch('changeChanceCount', payload);
      }
      // 群接龙
      if (getActivityType() === 'solitaireType') {
        store.dispatch('switchCanPay', { status: parameter.needPay });
        store.dispatch('changePayNumber', { number: parameter.payAmount / 100 });
        store.dispatch('changeSectionInfo', { type: 'courseName', value: content.courseName });
        store.dispatch('changeLeftQuota', leftQuota);
        store.dispatch('changeSectionInfo', { type: 'courseDesc', value: content.courseDesc });
        store.dispatch('changeSectionInfo', { type: 'coursePic', value: content.coursePic });
        // 兼容-课程描述-群接龙
        if (!content.courseIntros) {
          const _courseIntros = [];
          if (content.courseDesc) {
            _courseIntros.push({
              type: 'text',
              value: content.courseDesc
            });
          }
          if (content.coursePic) {
            let _list = content.coursePic.split('@').filter((item: string) => {
              return item;
            });
            for (let i = 0; i < _list.length; i++) {
              _courseIntros.push({
                type: 'img',
                value: _list[i]
              });
            }
          }
          store.dispatch('changeSectionInfo', { type: 'courseIntros', value: _courseIntros || [] });
        } else {
          store.dispatch('changeSectionInfo', { type: 'courseIntros', value: content.courseIntros || [] });
        }
        window.limitNum = parameter.limitNum;
      }

      if ((parameter as any).isLimited && getUrlParam('type') === 'reEdit') {
        const limitObject = {
          limitFlag: parameter.isLimited,
          limitFlagNumber: parameter.limitNum
        };
        store.dispatch('changeLimitFlag', limitObject);
      }

      if (
        isCopy &&
        supportPay &&
        channel !== 'XM_CASHIER' &&
        getUrlParam('instId') &&
        (xmPayRegisterStatusEnum !== 'SUCCESS' || wechatMiniOnlineStatus !== 'AUTH_SUCCESS')
      ) {
        store.dispatch('switchCanPay', { status: false });
      }
    })
    .catch((error: AxiosPromiseError) => {
      if (error.resultCode === 1403) {
        Vue.$toast.error('活动不存在');
      }
    });
}
